// import React from 'react'

// const TestimonialCarousel = () => {
//   return (
//     <>
//     <section>
//   <div class="testimonials max-w-7xl mx-auto p-4 sm:p-8">
//     <h2 class="heading-animation text-3xl lg:text-[36px] font-medium mb-6 mt-6 font-Calistoga text-slate-600 leading-relaxed text-center">
//       <span class="bg-gradient-to-r from-[#414de1] to-[#b241e1] bg-clip-text text-transparent">
//         Fostering
//       </span>{" "}
//       Success Together
//     </h2>

//     <div class="relative">
//       <div class="overflow-hidden">
//         <div
//           class="whitespace-nowrap transition-transform duration-500"
//           style={{ transform: "translateX(0%)" }} // Updated here
//         >
//           <div class="inline-block w-full" style={{ width: "100%" }}>
//             <div class="testimonial-container flex flex-col lg:flex-row items-center mb-8 bg-gray-100 py-12 px-6 lg:px-20 rounded-2xl font-Questrial">
//               <div class="testimonial-image-container lg:w-1/4 flex justify-center lg:justify-start mb-4 lg:mb-0">
//                 <img
//                   src="https://www.navishaa.com/assets/test-DlhaO39y.png"
//                   alt="Testimonial"
//                   class="testimonial-image w-60 h-60 rounded-lg object-cover shadow-lg"
//                 />
//               </div>

//               <div class="testimonial-content lg:w-3/4 text-center lg:text-left lg:pl-10 lg:pr-4">
//                 <p class="testimonial-text text-lg mb-4 text-gray-700 leading-loose break-words max-w-full text-wrap">
//                   Navishaa's experts have helped us to perform Microsoft 365 and Microsoft Azure health check-ups with detailed reports allowing to follow-up and convert customer 5X faster. With our recent campaign, we have seen a 7X success rate on solutions assessments on Microsoft Security and Copilot for Microsoft 365.
//                 </p>
//                 <div class="testimonial-footer flex flex-col lg:flex-row items-center lg:justify-between">
//                   <div class="testimonial-person flex items-center mt-4 lg:mt-0">
//                     <div class="person-image-container w-16 h-16 rounded-full overflow-hidden border-2 border-white shadow-md">
//                       <img
//                         src="https://www.navishaa.com/assets/testi-BihCQ2Dh.png"
//                         alt="Person"
//                         class="person-image w-full h-full object-cover"
//                       />
//                     </div>
//                     <div class="person-info ml-4">
//                       <p class="person-name text-lg font-semibold text-gray-900">
//                         Monal Shah
//                       </p>
//                       <p class="person-title text-sm text-gray-600">
//                         CEO at GetMax.ae
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div class="inline-block w-full" style={{ width: "100%" }}>
//             <div class="testimonial-container flex flex-col lg:flex-row items-center mb-8 bg-gray-100 py-12 px-6 lg:px-20 rounded-2xl font-Questrial">
//               <div class="testimonial-image-container lg:w-1/4 flex justify-center lg:justify-start mb-4 lg:mb-0">
//                 <img
//                   src="https://www.navishaa.com/assets/testOneImg-Bjxc9W4M.png"
//                   alt="Testimonial"
//                   class="testimonial-image w-60 h-60 rounded-lg object-cover shadow-lg"
//                 />
//               </div>

//               <div class="testimonial-content lg:w-3/4 text-center lg:text-left lg:pl-10 lg:pr-4">
//                 <p class="testimonial-text text-lg mb-4 text-gray-700 leading-loose break-words max-w-full text-wrap">
//                   Technical resources are highly skilled and able to manage customer requirement gathering from start to end. We have been able to scale our operations to multiple locations and different time zones through Navishaa's tech resource rental solutions.
//                 </p>
//                 <div class="testimonial-footer flex flex-col lg:flex-row items-center lg:justify-between">
//                   <div class="testimonial-person flex items-center mt-4 lg:mt-0">
//                     <div class="person-image-container w-16 h-16 rounded-full overflow-hidden border-2 border-white shadow-md">
//                       <img
//                         src="https://www.navishaa.com/assets/testOneImg-Bjxc9W4M.png"
//                         alt="Person"
//                         class="person-image w-full h-full object-cover"
//                       />
//                     </div>
//                     <div class="person-info ml-4">
//                       <p class="person-name text-lg font-semibold text-gray-900">
//                         Pankaj Jain
//                       </p>
//                       <p class="person-title text-sm text-gray-600">
//                         CEO at Navaida Solutions
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div class="flex justify-center mt-4 gap-3">
//           <button class="w-4 h-4 mx-2 rounded-full bg-[#ba195f]"></button>
//           <button class="w-4 h-4 mx-2 rounded-full bg-[#414de1]"></button>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>

//     </>
//   )
// }

// export default TestimonialCarousel

import React, { useState } from "react";

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array of testimonial data
  const testimonials = [
    {
      image: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747476348/test-DlhaO39y_r7cujt.png",
      text: "Navishaa's experts have helped us to perform Microsoft 365 and Microsoft Azure health check-ups with detailed reports allowing to follow-up and convert customer 5X faster. With our recent campaign, we have seen a 7X success rate on solutions assessments on Microsoft Security and Copilot for Microsoft 365.",
      name: "Monal Shah",
      title: "CEO at GetMax.ae",
      personImage: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747476348/testi-BihCQ2Dh_jjocwn.png",
    },
    {
      image: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747476348/testOneImg-Bjxc9W4M_fdihjx.png",
      text: "Technical resources are highly skilled and able to manage customer requirement gathering from start to end. We have been able to scale our operations to multiple locations and different time zones through Navishaa's tech resource rental solutions.",
      name: "Pankaj Jain",
      title: "CEO at Navaida Solutions",
      personImage: "https://res.cloudinary.com/dbitupkaa/image/upload/v1747476348/pj-6QzKfLOT_e8arql.png",
    },
  ];

  // Handle dot click
  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section>
      <div className="testimonials max-w-5xl mx-auto p-4 sm:p-8">
        <h2 className="heading-animation text-3xl lg:text-[30px] font-medium mb-6 mt-6 font-Calistoga text-slate-600 leading-relaxed text-center">
          <span className="bg-gradient-to-r from-[#414de1] to-[#b241e1] bg-clip-text text-transparent">
            Fostering
          </span>{" "}
          Success Together
        </h2>

        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="whitespace-nowrap transition-transform duration-500"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="inline-block w-full"
                  style={{ width: "100%" }}
                >
                  <div className="testimonial-container flex flex-col lg:flex-row items-center mb-8 bg-gray-100 py-8 px-6 lg:px-20 rounded-2xl font-Questrial">
                    <div className="testimonial-image-container lg:w-1/4 flex justify-center lg:justify-start mb-4 lg:mb-0">
                      <img
                        src={testimonial.image}
                        alt="Testimonial"
                        className="testimonial-image w-52 h-52 rounded-lg object-cover shadow-lg"
                      />
                    </div>

                    <div className="testimonial-content lg:w-3/4 text-center lg:text-left lg:pl-10 lg:pr-4">
                      <p className="testimonial-text text-sm mb-4 text-gray-700 leading-loose break-words max-w-full text-wrap">
                        {testimonial.text}
                      </p>
                      <div className="testimonial-footer flex flex-col lg:flex-row items-center lg:justify-between">
                        <div className="testimonial-person flex items-center mt-4 lg:mt-0">
                          <div className="person-image-container w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-md">
                            <img
                              src={testimonial.personImage}
                              alt="Person"
                              className="person-image w-full h-full object-cover"
                            />
                          </div>
                          <div className="person-info ml-4">
                            <p className="person-name text-sm font-semibold text-gray-900">
                              {testimonial.name}
                            </p>
                            <p className="person-title text-xs text-gray-600">
                              {testimonial.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Dots Navigation */}
            <div className="flex justify-center mt-4 gap-3">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleDotClick(index)}
                  className={`w-4 h-4 mx-2 rounded-full ${
                    currentIndex === index ? "bg-[#414de1]" : "bg-[#ba195f]"
                  }`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
